import React, { createContext, useContext, useState } from 'react';
import { initPersonMS } from '../../utils/types';

const ContextoPersona = createContext({});

export const PersonaProvider = ({ children }) => {
  const [infoPersona, setInfoPersona] = useState(initPersonMS());

  return (
    <ContextoPersona.Provider
      value={{
        infoPersona,
        setInfoPersona,
      }}
    >
      {children}
    </ContextoPersona.Provider>
  );
};

export const usePersona = () => useContext(ContextoPersona);